import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import { TransformWrapper } from 'react-zoom-pan-pinch';
import { Box } from '@mui/material';
import stylesDocument from '../document.module.scss';
import { Preview } from './Preview';
import { useDocumentStore } from '@entities/project/document';
import { useLazyImageLoad } from '@shared/lib/hooks/useLazyImageLoad';
export function DocumentPreview({ resizeCallbackRef }) {
    const { page, reset } = useDocumentStore();
    const imageWrapperRef = useRef(null);
    const divRef = useRef(null);
    const { isFetched } = useLazyImageLoad(page === null || page === void 0 ? void 0 : page.image_high);
    const [panPinchState, setPanPinchState] = useState({
        previousScale: 1,
        scale: 1,
        positionX: 0,
        positionY: 0
    });
    const handleMouseWheel = (ref) => {
        setPanPinchState(Object.assign({}, ref.state));
    };
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    useEffect(() => {
        const handleResize = () => {
            if (!imageWrapperRef.current || !isFetched)
                return;
            const { width, height } = imageWrapperRef.current.getBoundingClientRect();
            const transformElement = imageWrapperRef.current.querySelector('.react-transform-component');
            if (transformElement) {
                const { width: childWidth, height: childHeight } = transformElement.getBoundingClientRect();
                const centerX = (width - childWidth) / 2;
                const centerY = (height - childHeight) / 2;
                if (centerX > 0 && centerY > 0) {
                    // Use the current scale from panPinchState
                    transformElement.style.transform = `translate(${centerX}px, ${centerY}px) scale(${panPinchState.scale})`;
                }
            }
        };
        // Debounce function to limit the frequency of handleResize calls
        let resizeTimeout;
        const handleResizeDebounced = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(handleResize, 200);
        };
        // Assign the resize handler to the ref
        if (resizeCallbackRef) {
            resizeCallbackRef.current = handleResize;
        }
        // Initial call
        handleResize();
        // Create a ResizeObserver to track changes to imageWrapperRef
        const resizeObserver = new ResizeObserver(handleResizeDebounced);
        if (imageWrapperRef.current) {
            resizeObserver.observe(imageWrapperRef.current);
        }
        return () => {
            if (resizeCallbackRef) {
                resizeCallbackRef.current = null;
            }
            if (imageWrapperRef.current) {
                resizeObserver.unobserve(imageWrapperRef.current);
            }
            resizeObserver.disconnect();
        };
    }, [isFetched, panPinchState.scale]); // Add panPinchState.scale to dependencies
    return (_jsx(Box, { className: stylesDocument.pageReview, children: page && (_jsx(Box, { className: stylesDocument.pageImageWrapper, ref: imageWrapperRef, children: _jsx("div", { ref: divRef, style: { width: '100%', height: '100%' }, children: _jsx(TransformWrapper, { initialScale: 1, onTransformed: (ref) => {
                        handleMouseWheel(ref);
                        // Call resize callback with new scale
                        if (resizeCallbackRef.current) {
                            resizeCallbackRef.current();
                        }
                    }, panning: { excluded: ['text', 'span'] }, children: ({ zoomIn, zoomOut, resetTransform }) => (_jsx(Preview, { panPinchState: panPinchState, zoomIn: zoomIn, zoomOut: zoomOut, resetTransform: resetTransform, resizeCallbackRef: resizeCallbackRef })) }) }) })) }));
}
